import { render, staticRenderFns } from "./CsvErrorCard.vue?vue&type=template&id=126ebba6"
import script from "./CsvErrorCard.vue?vue&type=script&lang=js"
export * from "./CsvErrorCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports